<script lang="ts">
    import { getContext } from 'svelte';
    import { uploadSheets  } from './src/client';
    import { Sheet } from './src/types';
    import { push } from 'svelte-spa-router'

    let files : FileList;
    
    export let option;
    
    let checked = false;
    
    export let onCancel = () => {};
    export let onOkay = () => {};

    const { close } = getContext('simple-modal') as any;

    const setAuthenticated = getContext<(boolean) => void>('setAuthenticated');
    

    async function _onCancel() {
        await onCancel();
        option = false;
        close();
    }

    async function  _onOkay() {        
        let sheets : Sheet[] = [];

        for (let i = 0; i < files.length; i++) {            
            const file = files.item(i);
            const content = await file.text();
            let shs:Sheet[] = JSON.parse(content);
            sheets = sheets.concat(shs);
        }
        let up = await uploadSheets(sheets);
        if (!up.authorized) {
            close();
            setAuthenticated(false);
            push('/login');
            return;
        }
        await onOkay();

        close();
    }

    
</script>

<style>
    h2 {
        font-size: 2rem;
        text-align: center;
    }

    .buttons {
        display: flex;
        justify-content: space-between;
    }
</style>

<h2>Envoyer des feuilles de match</h2>

<label for="files">feuilles:</label>
<input accept="application/json" bind:files id="files" name="files" type="file" />



<div class="buttons">
    <button on:click={_onCancel}>
        Cancel
    </button>
    <button on:click={_onOkay}>
        Ok
    </button>
</div>